import { render, staticRenderFns } from "./fattoria-le-pupille.vue?vue&type=template&id=1a20c45a&scoped=true"
import script from "./fattoria-le-pupille.vue?vue&type=script&lang=js"
export * from "./fattoria-le-pupille.vue?vue&type=script&lang=js"
import style0 from "./fattoria-le-pupille.vue?vue&type=style&index=0&id=1a20c45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a20c45a",
  null
  
)

export default component.exports